import styled from 'styled-components';
import { COLORS, MQS, FONT_FAMILY } from '../../../app/common/constants/styles';

export const RewardsContainer = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    flex-direction: column;
    cursor: default;
    .rewards-info {
        vertical-align: top;
        margin-left: 8px;
        width: 24px;
        cursor: pointer;
    }
    .red-rectangle-gradient {
        background-image: linear-gradient(
            166deg,
            #904aa2 0%,
            #ab2883 21%,
            #c61655 38%,
            #db7392 69%,
            #e8727e 91%
        );
        @media (min-width: ${MQS.mq2Min}) {
            background-image: linear-gradient(
                97deg,
                #904aa2 -4%,
                #ab2883 20%,
                #c61655 40%,
                #db7392 76%,
                #e8727e 101%
            );
        }
    }

    .blue-rectangle-gradient {
        background-image: linear-gradient(
            166deg,
            #1c98e0 -4%,
            #4390a7 20%,
            #4893bf 40%,
            #4fb7c1 76%,
            #60d8ff 101%
        );
        @media (min-width: ${MQS.mq2Min}) {
            background-image: linear-gradient(
                97deg,
                #1c98e0 -4%,
                #4893bf 20%,
                #4390a7c4 40%,
                #4fb7c1 76%,
                #60d8ff 101%
            );
        }
    }
`;

export const RewardsTitle = styled.div`
    margin: 10px;
    font-size: 0.75rem;
    letter-spacing: normal;
    color: ${COLORS.white};

    @media (min-width: ${MQS.mq3Max}) {
        font-size: 1rem;
    }
`;

export const RewardsSemiBoldTitle = styled(RewardsTitle)`
    font-size: 1.125rem;
`;

export const RewardsAmount = styled.span`
    margin: 10px;
    font-size: 1.75rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    color: ${COLORS.white};
    ${FONT_FAMILY.multipleSemiBoldCss};
    width: inherit;
    word-wrap: break-word;

    @media (min-width: ${MQS.mq2Min}) {
        width: 95%;
    }
    @media (min-width: ${MQS.mq3Min}) {
        font-size: 2.5rem;
    }
`;

export const RewardsAmountText = styled.span`
    font-size: 1.25rem;
    white-space: pre-line;
    ${FONT_FAMILY.multipleRegularCss};
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: ${COLORS.white};
    margin-left: 6px;
    @media (min-width: ${MQS.mq2Min}) {
        font-size: 1.375rem;
        margin-left: 12px;
    }
`;

export const RewardsHeader = styled.div`
    font-size: 1.5rem;
    color: ${COLORS.white};
    font-weight: 600;
    margin: 12px 0 2px 10px;
    display: none;
    @media (min-width: ${MQS.mq2Min}) {
        display: block;
        font-size: 1.875rem;
    }
`;

export const RewardsLeftHeader = styled(RewardsHeader)`
    display: block;
`;

export interface RewardsContainerProps {
    bannerType: string;
}

export const RewardsRectangle = styled.div`
    display: flex;
    flex-direction: column;
    padding: 6px;
    margin: 12px;
    position: relative;
    border-radius: 8px;
    font-size: 1.25rem;
    white-space: pre-line;
    font-family: ${FONT_FAMILY.multipleRegularCss};
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    box-shadow: 10px 10px 20px 0 rgba(36, 11, 52, 0.1);

    @media (min-width: ${MQS.mq2Min}) {
        flex-direction: row;
    }
`;

export const RewardsRectangeContainer = styled.div`
    margin-left: 6px;
    justify-content: space-around;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    @media (min-width: ${MQS.mq2Min}) {
        width: 50%;
    }
`;
export const RewardsRectangleLeftContainer = styled(RewardsRectangeContainer)`
    border-bottom-style: solid;
    border-bottom-color: white;
    border-bottom-width: 2px;
    width: 90%;

    @media (min-width: ${MQS.mq2Min}) {
        border-right-style: solid;
        border-right-color: white;
        border-right-width: 2px;
        border-bottom-style: none;
        width: 50%;
    }
`;
